import type { CommonAction } from "@iflyrpa/share";
import { z } from "zod";
import { ActiomCommonParams, ActionCommonParamsSchema } from "../../types";
import { executeAction } from "../../utils";
import { mockAction } from "./mock";
import { rpaAction } from "./rpa";

/**
 * 作品声明
 * 1：引用站内
 * 3：引用AI
 * 4：取材网络
 * 5：个人观点，仅供参考
 * 6：虚构演绎，故事经历
 * 7：投资观点，仅供参考
 * 8：健康医疗分享，仅供参考
 */
type DeclarationType = 1 | 3 | 4 | 5 | 6 | 7 | 8;

export interface WeitoutiaoPublishParams extends ActiomCommonParams {
    content: string;
    banners?: string[];
    address?: string;
    declaration?: DeclarationType;
}

export type PublishAction = CommonAction<WeitoutiaoPublishParams>;

export const weitoutiaoPublish: PublishAction = async (task, params) => {
    if (params.actionType === "rpa") {
        return rpaAction(task, params);
    }

    if (params.actionType === "mockApi") {
        return mockAction(task, params);
    }

    return executeAction(mockAction, rpaAction)(task, params);
};
